import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import Loader from "./components/loader/Loader";
import store from "./app/store";
import App from "./app/App";
import { setAuthToken } from "./utils/api_instance.util";

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { checkSession } from "./features/loginSlice";

const token = localStorage.getItem("token") || "";
if (token) {
	setAuthToken(token);
}
store.dispatch(checkSession());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<BrowserRouter>
				<DndProvider backend={HTML5Backend}>
					<Suspense fallback={<Loader />}>
						<App />
					</Suspense>
				</DndProvider>
			</BrowserRouter>
		</Provider>
	</React.StrictMode>
);
